import { QRCodeOptions } from "qrcode";
import * as QRCode from "qrcode";
import { Observable } from "rxjs";

export namespace RxQR {
	export function toDataURL(text: string) {
		return new Observable<string>((o) => {
			QRCode.toDataURL(text, (err, dataUrl) => {
				if (err != null) {
					o.error(err);
				}
				else {
					o.next(dataUrl);
				}
				
				o.complete();
			});
		});
	}
}
